module.exports = __webpack_public_path__ + "static/media/xanga_ventures_logo.4d083e79.png";